import { Component } from '@angular/core';
import { FileType } from '@lsq-frontend/remote-services/enterprise/common';
import {
    GetImageUrlRequest,
    GetInvoiceBatchImageUrlService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { BaseImagePreviewComponent } from './base-image-preview.component';

@Component({
    selector: 'invoice-preview',
    template: `
        <lsq-image-preview
            #imagePreviewElement
            [imageType]="'invoice'"
            [imageUrl]="imageUrl"
            [filename]="filename"
            [downloadUrl]="downloadUrl"
            [totalPages]="totalPages"
            [page]="currentPage"
            (pageChange)="handlePageChange($event)"
            (fetchImage)="getImageUrl()"
        >
        </lsq-image-preview>
    `
})
export class InvoicePreviewComponent extends BaseImagePreviewComponent {
    constructor(private _getInvoiceBatchImageUrlService: GetInvoiceBatchImageUrlService) {
        super();
    }

    public async getImageUrl(): Promise<void> {
        if (
            !this.imagePreviewElement ||
            typeof this.imagePreviewElement.maxSize === 'undefined' ||
            typeof this.imagePreviewElement.zoomLevel === 'undefined'
        ) {
            return;
        }

        const getInvoiceBatchImageUrlRequest = new GetImageUrlRequest();
        getInvoiceBatchImageUrlRequest.imageKey = this.imageId;
        getInvoiceBatchImageUrlRequest.format = FileType.Jpg;
        getInvoiceBatchImageUrlRequest.cropFit = true;

        if (typeof this.currentPage !== 'undefined') {
            if (this._isMultiImage) {
                getInvoiceBatchImageUrlRequest.imageKey = this.imageIds[this.currentPage - 1];
                this.activeImageId = getInvoiceBatchImageUrlRequest.imageKey;
            } else {
                getInvoiceBatchImageUrlRequest.page = this.currentPage;
            }
        }
        if (typeof this.imagePreviewElement.zoomLevel !== 'undefined') {
            const maxWidthAndHeight = Math.floor(
                this.imagePreviewElement.maxSize * this.imagePreviewElement.zoomLevel
            );
            getInvoiceBatchImageUrlRequest.zoom = this.imagePreviewElement.zoomLevel * 100;
            getInvoiceBatchImageUrlRequest.width = maxWidthAndHeight;
            getInvoiceBatchImageUrlRequest.height = maxWidthAndHeight;
        }

        const getImageUrlResponse = await this._getInvoiceBatchImageUrlService.executeOnce(
            getInvoiceBatchImageUrlRequest
        );
        this.imageUrl = getImageUrlResponse.url;
    }
}
